import PptxGenJS from "pptxgenjs";
import {
  BRAND_WATERMARK,
  PAGE_TITLE_TEXT,
  PRIVATE_AND_CONFIDENTIAL_TEXT,
  SPLIT_PANEL_BOTTOM_SMALL,
} from "./components";

export const SPLIT_BOTTOM_SMALL_MASTER = "SPLIT_BOTTOM_SMALL_MASTER";

export const splitBottomSmallMasterSlide: PptxGenJS.SlideMasterProps = {
  title: SPLIT_BOTTOM_SMALL_MASTER,
  background: {
    color: "#FFFFFF",
  },
  objects: [
    PAGE_TITLE_TEXT,
    SPLIT_PANEL_BOTTOM_SMALL,
    PRIVATE_AND_CONFIDENTIAL_TEXT,
    BRAND_WATERMARK,
  ],
  slideNumber: {
    x: "50%",
    y: "95%",
    fontSize: 8,
    color: "#000000",
  },
};
